/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "adminToolbar": "_R2mbdxOJd",
  "businessAreas": "Zq1elegAWR",
  "drupalUser": "sNc-Q0VM7u",
  "initData": "1ZKog-7K9q",
  "loadTranslations": "y2gCZ07nBY",
  "localTasks": "4KpYWXogBj",
  "newsList": "MsltMOxXAM",
  "newsTeaserList": "qzIAb85rK4",
  "pbAddClipboardText": "76-n8nV6Rs",
  "pbAddComment": "ndl0-MmxVg",
  "pbAddEntityReference": "1Us7ui5dsp",
  "pbAddEntityReferenceMultiple": "hfP-NodnJ8",
  "pbAddFile": "Z3RvCrYT_s",
  "pbAddFragmentParagraph": "pSBwg3XXol",
  "pbAddImage": "GnaHOBaE6S",
  "pbAddParagraph": "KeVpXfZwAP",
  "pbAddReusableParagraph": "XurzX_c91Z",
  "pbAddVideoRemote": "7Y-Q0JJP5o",
  "pbApplyTransformPlugin": "Zh5xKQq9dg",
  "pbBulkUpdateParagraphBehaviorSettings": "Lp5WEL9C0N",
  "pbComments": "eLhHrN5PPt",
  "pbConfig": "S8qpiEegF_",
  "pbConversions": "hIb-h-hpru",
  "pbConvertMultiple": "Ka20UM9H-R",
  "pbConvertParagraph": "wXqYCBW0qY",
  "pbCopyFromExisting": "72t6hV3Ipp",
  "pbDeleteMultipleParagraphs": "tELXLh0K-m",
  "pbDeleteParagraph": "xBOmOxG4Qp",
  "pbDetachReusableParagraph": "eVnTGFF7fJ",
  "pbDuplicateMultipleParagraphs": "hRXSgz_68s",
  "pbDuplicateParagraph": "TytHGqvP80",
  "pbEditState": "aX73JGXkDO",
  "pbGetImportSourceEntities": "va6PnAMoeJ",
  "pbGetPreviewGrantUrl": "sAJOzxHeUi",
  "pbGetTransformPlugins": "qa4M4JfbbI",
  "pbLibraryItems": "U6H-ktmSaw",
  "pbMakeParagraphReusable": "tj-MGB7_bS",
  "pbMediaLibraryGetResults": "gA3YxwjAUh",
  "pbMoveMultipleItems": "M84d9nvWZR",
  "pbMoveParagraph": "vBLlN3nNol",
  "pbPublish": "R8BRKdFCp1",
  "pbRedo": "GK1pUdnsir",
  "pbReplaceHostEntityMedia": "6e7JP1ZVId",
  "pbReplaceMedia": "xqJktDNLs0",
  "pbResolveComment": "gAt359uTiN",
  "pbRevertAllChanges": "ckzdTsKqFc",
  "pbSearch": "gZi3jFPAyy",
  "pbSearchTabs": "3jxTsFlHH7",
  "pbSetHistoryIndex": "HHm9uw-O6H",
  "pbSetMutationItemStatus": "4E6HY3hFcr",
  "pbTakeOwnership": "W4XfkXWfFI",
  "pbUndo": "SkNe8Vxb68",
  "pbUpdateFieldValue": "zTWyzLflYT",
  "pbUpdateHostEntityFieldValue": "HvA2OPh8-u",
  "pbUpdateParagraphOption": "cETQkmRNRS",
  "routeNodeCanonical": "yXfTYn_dJY",
  "routeNodePage": "w5vDQVincr",
  "routeNodePressRelease": "1skKOQ28C2",
  "routeSlug": "AtK-P1uXZn",
  "routeWebform": "BLg2AIr6uJ",
  "search": "0dvHttaVOk",
  "submitWebform": "TgnEpmhTJP",
  "webformConfirmation": "GCKVdyHElr"
}